import axios from 'axios';

const baseURL =
  process.env.NODE_ENV === 'production' && process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`
    : '/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = String(error.config?.url || '');
    const isPublicAssessment =
      url.includes('/public/assessments/') ||
      url.includes('public/assessments/');
    if (error.response?.status === 401 && !isPublicAssessment) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
